export type Config = Partial<{
  home: {
    url: string;
  };
  navigation: {
    label: string;
    url: string;
    childItems: { label: string; url: string }[];
  }[];
  supportContact: Partial<{
    display: boolean;
    url: string;
  }>;
}>;

export const defaultConfig: Config = {
  home: {
    url: '/'
  },
  navigation: [
    {
      label: 'Buy',
      url: '/buy',
      childItems: []
    },
    {
      label: 'Sell',
      url: '/sell',
      childItems: []
    }
  ],
  supportContact: {
    display: false,
    url: 'https://carvana.com'
  }
};

// Used to only allow certian fields in the config to be overridden
export type HeaderConfig = Partial<{
  home: { url: string };
  supportContact: Partial<{ display: boolean; url: string }>;
}>;
